<template>
  <overlay :is-active="isOpen">
    <nav
      :aria-label="$t('section__sidebar')"
      class="
        tw-bg-white
        tw-box-content
        tw-fixed
        tw-flex
        tw-h-10
        tw-py-2
        tw-shadow-md
        tw-top-0
        tw-w-screen
        tw-z-40
        xl:tw-absolute
        xl:tw-bg-[#f8f8f8]
        xl:tw-box-border
        xl:tw-items-center
        xl:tw-justify-end
        xl:tw-max-w-[100vw]
        xl:tw-px-52
        xl:tw-shadow-none
        xl:tw-z-30
      "
    >
      <div
        class="
          tw-flex tw-w-full
          xl:tw-container xl:tw-mx-auto xl:tw-justify-end
        "
      >
        <div class="tw-flex-grow tw-pl-5 xl:tw-hidden">
          <div
            :class="{ open: isOpen }"
            class="tw-inline-block nav-toggle"
            @click="isOpen = !isOpen"
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div class="tw-flex-initial tw-pr-5 xl:tw-pr-0">
          <nuxt-link
            class="tw-inline-block xl:tw-hidden"
            to="/"
            @click.native="isOpen = false"
          >
            <img
              alt="UpTogether"
              class="tw-h-10 tw-ml-auto tw-object-contain"
              src="/logo.png"
            />
          </nuxt-link>

          <identity
            class="tw-hidden xl:tw-flex"
            @signout="logoutModal = true"
          />
        </div>
      </div>
    </nav>

    <navigation-menu
      :is-open="isOpen"
      @close="isOpen = false"
      @signout="signout"
    />

    <options-box
      v-model="logoutModal"
      mode="modal"
      :options="[
        {
          title: $t('log_out_no'),
          class: 'tw-bg-[#c4c4c4]',
          onClick: () => (logoutModal = false),
        },
        {
          title: $t('log_out_yes'),
          class: 'tw-bg-white tw-border tw-border-black',
          onClick: () => signout(),
        },
      ]"
      :title="$t('log_out_confirmation_message')"
    />
  </overlay>
</template>

<script>
import NavigationMenu from '@/components/navbar/NavigationMenu'
import Identity from '@/components/Identity.vue'
import Overlay from '@/components/shared/Overlay'
import OptionsBox from '@/components/shared/options_box/OptionsBox'

export default {
  components: {
    Identity,
    NavigationMenu,
    Overlay,
    OptionsBox,
  },
  data() {
    return {
      isOpen: false,
      logoutModal: false,
    }
  },
  methods: {
    signout() {
      this.$analytics.sendEvent('user_logout')
      this.$store.dispatch('fiiAuth/logout')
      this.isOpen = false
      location.reload()
    },
  },
}
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.nav-toggle {
  margin-top: 8px;
  position: relative;
  user-select: none;
  z-index: 1;

  span {
    background: #000;
    border-radius: 3px;
    display: block;
    height: 4px;
    margin-bottom: 5px;
    position: relative;
    transform-origin: 4px 0px;
    transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1);
    width: 31px;
    z-index: 1;

    &:first-child {
      transform-origin: 0% 0%;
    }

    &:nth-last-child(2) {
      transform-origin: 0% 100%;
    }
  }

  &.open span {
    opacity: 1;
    transform: rotate(45deg) translate(0px, 0px);

    &:nth-last-child(1) {
      transform: rotate(-45deg) translate(-4px, -3px);
    }

    &:nth-last-child(2) {
      opacity: 0;
      transform: rotate(0deg) scale(0.2, 0.2);
    }
  }
}
</style>
